// Zod Schema pour les Utilisateurs.

import * as z from "zod";

export const userSchema = z.object({
  username: z.string().min(1, "Username is required"),
  password: z.string().min(1, "Password is required"),
  tenant_id: z.string().regex(/^\d+$/, "Tenant ID must be a number"),
  wordpress_domain: z.string().min(1, "WordPress Domain is required"),
  chatwoot_domain: z.string().optional(),
  wordpress_user: z.string().min(1, "WordPress User is required"),
  wordpress_password: z.string().min(1, "WordPress Password is required"),
  chatwoot_user: z.string().optional(),
  chatwoot_password: z.string().optional(),
  wordpress_cookies: z.string().optional(),
  chatwoot_cookies: z.string().optional(),
  printing_capabilities: z.boolean(),
  cashdrawer_capabilities: z.boolean(),
  second_screen_capabilities: z.boolean(),
  avoir_decaisser_capabilities: z.boolean(),
});
